<template>
  <div>
    <div
      v-if="requestLoading || viewLoading"
      v-loading="requestLoading || viewLoading"
      :style="{height: clientHeight-53 + 'px'}"
      :element-loading-text="loadingText"
      element-loading-background="transparent">
    </div>
    <div class="task-review question-review">
      <div class="task-workspace"
           :style="{height: height + 'px', margin: '0'}">
        <div class="task-question">
          <section ref="taskQuestion">
            <div>
              <question-review>
                <OrderReviewQuestion
                  v-if="!requestLoading"
                  v-show="!viewLoading"
                  v-for="(question, index) in questions"
                  :key="question.id"
                  :question-index="index"
                  :question="question"
                  :answer="answers[index]"/>
              </question-review>
            </div>
          </section>
        </div>
        <div class="task-tool">
          <section class="panel"
                   ref="taskTool">
            <div class="panel--body">
              <OrderReviewSidebar v-if="!requestLoading"
                                  v-show="!viewLoading"/>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '../teke-order-review.scss'
import '@views/question-review/question-review.scss'
import questionReview from '@views/question-review/question-review.js'
import PerfectScrollbar from 'perfect-scrollbar'
import OrderReviewQuestion from './TekeOrderReviewQuestion'
import OrderReviewSidebar from './TekeOrderReviewSidebar'
import CacheManage from '@views/question-review/components/CacheManage'
import QuestionReview from '@/views/question-review/packages/QuestionReview/src/QuestionReview'

let questionScrollbar = null
let toolScrollbar = null
export default {
  components: {QuestionReview, OrderReviewQuestion, OrderReviewSidebar},
  mixins: [],
  data () {
    return {
      isCollapse: false,
      questions: [],
      answers: [],
      requestLoading: true,
      viewLoading: true,
      loadingText: '拼命加载中',
      answerChangeTotal: 0,
    }
  },
  computed: {
    ...Vuex.mapState({
      clientHeight: state => state.clientHeight,
      orderDetail: state => state.orderReview.orderDetail,
    }),
    height () {
      return this.clientHeight - 81 - 20
    },
  },
  watch: {
    answers: {
      handler (val) {
        this.$store.commit('orderReview/SET_PHOTO_COUNT', questionReview().getAnswerPhotoCount())
      },
      deep: true,
    },
  },
  beforeCreate () {
    this.$store.commit('COLLAPSE_MENU')
    // 对上一次缓存的临时缓存，转移到版本缓存中
    CacheManage.moveTempToVersionItem()
  },
  created () {
    this.init()
  },
  destroyed () {
    CacheManage.destroy()
  },
  mounted () {
    this.collapse(true)
    // let $main = $(this.$el).parent()
    // $main.scroll((event) => {
    //   if (this.viewLoading === false && this.isCollapse === false && this.$refs.taskInfo.offsetHeight - $main.scrollTop() <= this.summaryToolHeight) {
    //     this.collapse(true)
    //     $main.scrollTop(0)
    //   }
    // })
    this.$nextTick(() => {
      this.$store.commit('orderReview/SET_QUESTION_CONTAINER_ELEMENT', this.$refs.taskQuestion)
    })
  },
  methods: {
    ...Vuex.mapActions([]),
    handleOrderDetail () {
      this.loadingText = '数据处理中'
      // 异步使视图先更改
      setTimeout(() => {
        // 数据处理中 视图更改完毕
        this.$nextTick(() => {
          questionReview().init(
            JSON.parse(this.orderDetail.templatejson).steps,
            this.orderDetail.templateresultjson ? JSON.parse(this.orderDetail.templateresultjson) : null)
          // 载入数据
          this.$set(this, 'questions', questionReview().getQuestions())
          this.$set(this, 'answers', questionReview().getAnswers())
          this.loadingText = '视图加载中'
          // 异步使视图先更改
          setTimeout(() => {
            this.requestLoading = false
            // 视图加载中 视图更改完毕
            this.$nextTick(() => {
              // 异步使视图先更改
              setTimeout(() => {
                // 全部加载完成 视图更改完毕
                this.$nextTick(() => {
                  this.viewLoading = false
                })
              })
            })
          })
        })
      })
    },
    init () {
      this.loadingText = '请求加载中'
      this.handleOrderDetail()
    },
    collapse (bool) {
      if (bool) {
        this.isCollapse = true
        if (!questionScrollbar) {
          questionScrollbar = new PerfectScrollbar(this.$refs.taskQuestion, {
            wheelPropagation: true,
            minScrollbarLength: 30,
          })
          this.$refs.taskQuestion.addEventListener('ps-scroll-y', () => {
            this.isCollapse = true
          })
        }
        if (!toolScrollbar) {
          toolScrollbar = new PerfectScrollbar(this.$refs.taskTool, {
            wheelPropagation: true,
            minScrollbarLength: 30,
          })
          this.$refs.taskTool.addEventListener('ps-scroll-y', () => {
            this.isCollapse = true
          })
        }
      } else {
        this.isCollapse = false
      }
    },
  },
}
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/teke-order-review/pages/TekeOrderReview.vue